module.exports = __webpack_public_path__ + "img/me-dev.f4838445.png";